import { useCallback } from "react";
import useGeoPolygons from "../../../../api/hooks/use-geo-polygon";
import { EMarketTypes } from "../../../../interfaces";
import Loader from "../../../ui/loader";
import ChooseMapPolygon from "../../../ui/map/polygon/chooseMapPolygon";
import BaseStep from "./baseStep";
import styles from "./styles.module.scss";
import { ICounterPage } from "./types";
interface IChooseAreaStep {
  data: number[] | null;
  handleNextStep: () => void;
  handlePrevStep: () => void;
  isNextStepDisabled: boolean;
  counterPage?: ICounterPage;
  onChange: (data: number[], key: "desiredLocationIds") => void;
}

const ChooseAreaStep = ({
  data,
  handleNextStep,
  handlePrevStep,
  isNextStepDisabled,
  onChange,
  counterPage,
}: IChooseAreaStep) => {
  const { polygons, isLoading, mutate } = useGeoPolygons();

  const handleChange = (data: number[]) => {
    onChange(data, "desiredLocationIds");
  }

  if (isLoading) {
    return (
      <div className={styles.loader}>
        <Loader />
      </div>
    );
  }

  if (!polygons.length) {
    return (
      <div className={styles.errorLoadedData}>
        Ошибка загрузке данных попробуйте позже
      </div>
    );
  }

  return (
    <div className={styles.chooseAreaStep}>
      <BaseStep
        counterPage={counterPage}
        nextStep={handleNextStep}
        prevStep={handlePrevStep}
        text="В каком районе хотите жить? (максимум 3 зоны)"
        isNextStepDisabled={isNextStepDisabled}
      >
        <div className={styles.chooseAreaStep__map}>
          {polygons.length && !isLoading && (
            <ChooseMapPolygon
              type={EMarketTypes.SECONDARY}
              onChange={handleChange}
              selectedIds={data || []}
              polygonItems={polygons}
            />
          )}
        </div>
      </BaseStep>
    </div>
  );
};

export default ChooseAreaStep;
